module.exports = __webpack_public_path__ + "img/pt.6de0efa5.svg";